import React, { createContext, useContext, useMemo } from 'react';

import {
  createHttpClient,
  IHttpClient,
  useEnvironment,
} from '@wix/yoshi-flow-editor';

import { useMockClient } from '@/__tests__/HttpClientContext';

const HttpClientContext = createContext({
  get httpClient(): IHttpClient {
    throw new Error('httpClient is not provided');
  },
});

export const HttpClientProvider: React.FC<
  React.PropsWithChildren<{
    instance: string;
  }>
> = ({ instance, children }) => {
  const { isSSR } = useEnvironment();

  const mockClient = useMockClient();
  const httpClient = useMemo(
    () =>
      createHttpClient({
        isSSR,
        getAppToken: () => instance ?? '',
      }),
    [instance, isSSR],
  );

  return (
    <HttpClientContext.Provider
      value={{
        httpClient: mockClient ?? httpClient,
      }}
    >
      {children}
    </HttpClientContext.Provider>
  );
};

export const useHttpClient = () => useContext(HttpClientContext).httpClient;
